import { Navigate, Route, Routes } from "react-router";
import { useSession } from "./lib/session";
import { useTill } from "./lib/till-context";
import { Layout } from "./components/Layout";
import { Spinner } from "./components/ui";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { ShopDashboard } from "./pages/ShopDashboard";
import { Products } from "./pages/Products";
import { StockLogPage, StockMoves } from "./pages/StockMoves";
import { PlainCount } from "./components/PlainCount";
import { Customers } from "./pages/Customers";
import { Staff } from "./pages/Staff";
import { Reports } from "./pages/Reports";
import { TellerReports } from "./pages/TellerReports";
import { Catalog, CashControl, Discounts, Permissions } from "./pages/Control";
import { Refunds } from "./pages/Refunds";
import { Settings, ShopsAndTills } from "./pages/Settings";
import { Activity } from "./pages/Activity";
import { Team } from "./pages/Team";
import { Join } from "./pages/Join";
import { Suppliers } from "./pages/Suppliers";
import { OwedPage, StockHealthPage } from "./components/Insights";

/** The shop's back office: sign in with a store admin account, then the pages. No selling here. */
export function App() {
  const s = useSession();
  const { me, loading } = useTill();
  // An invite link works signed out: the person sets their password there.
  const join = window.location.pathname.match(/^\/join\/([A-Za-z0-9]+)/);
  if (join && !s.token) return <Join code={join[1]!} />;
  if (!s.token) return <Login />;
  if (loading || !me)
    return (
      <div className="grid h-full place-items-center">
        <Spinner />
      </div>
    );
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={import.meta.env.VITE_BRAND ? <ShopDashboard /> : <Dashboard />} />
        <Route path="products" element={<Products />} />
        <Route path="stock" element={<StockMoves />} />
        <Route path="count" element={<PlainCount />} />
        <Route path="log" element={<StockLogPage />} />
        <Route path="customers" element={<Customers />} />
        <Route path="staff" element={<Staff />} />
        <Route path="reports" element={import.meta.env.VITE_BRAND ? <TellerReports /> : <Reports />} />
        <Route path="catalog" element={<Catalog />} />
        <Route path="suppliers" element={<Suppliers />} />
        <Route path="discounts" element={<Discounts />} />
        <Route path="refunds" element={<Refunds />} />
        <Route path="cash" element={<CashControl />} />
        <Route path="permissions" element={<Permissions />} />
        <Route path="activity" element={<Activity />} />
        <Route path="settings" element={<Navigate to="/settings/tills" replace />} />
        <Route path="settings/tills" element={<ShopsAndTills />} />
        <Route path="settings/:section" element={<Settings />} />
        <Route path="team" element={<Team />} />
        <Route path="owed" element={<OwedPage />} />
        <Route path="health" element={<StockHealthPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
